(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tamecare-promo-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('TamecarePromoPopup');

    if (!popup || typeof popup.showModal !== 'function') return;

    const storageKey = 'tamecare-first-aid-popup-2026-08-31-live-v2';
    const threeDays = 3 * 24 * 60 * 60 * 1000;
    const expiresAt = Date.parse('2026-09-01T04:00:00Z');
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    let lastClosed = 0;

    if (Date.now() >= expiresAt) return;

    try {
      lastClosed = Number(window.localStorage.getItem(storageKey) || 0);
    } catch (error) {
      lastClosed = 0;
    }

    if (!designMode && Date.now() - lastClosed < threeDays) return;

    const rememberClose = () => {
      if (!popup.open) return;

      popup.close();

      if (designMode) return;

      try {
        window.localStorage.setItem(storageKey, String(Date.now()));
      } catch (error) {
        return;
      }
    };

    popup.querySelector('[data-tamecare-popup-close]')?.addEventListener('click', rememberClose);
    popup.querySelector('.tamecare-promo-popup__link')?.addEventListener('click', rememberClose);
    popup.addEventListener('cancel', rememberClose);
    popup.addEventListener('click', (event) => {
      if (event.target === popup) rememberClose();
    });

    window.setTimeout(() => {
      if (!popup.open) popup.showModal();
    }, 12000);
  })();
  } catch(e) { console.error(e); }
})();

})();
